import React from "react"

type Props = {
    style?: any

    message: string
}

export default function Modal_StateMessage(props: Props) {

    const style = props.style || {height: 'calc(100% - 100px)'}

    return (
        <div className="flex-row-center-center" style={style}>
            <div className="ui5-txt-not-important-small">
                {props.message}
            </div>
        </div>
    )
}